<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
</svg>
